export default function CompletedAuditController(
  $filter,
  $q,
  $rootScope,
  $scope,
  alerts,
  amDataService,
  amSharedModelService,
  confirmDialog,
  editAuditDialog,
  loaderService,
  orgDataService,
  ssDialogService,
  reportsDataService,
) {
  const vm = this;
  
  vm.groupId = 16;

  vm.canExpand = true;
  vm.isExpanded = false;
  vm.isGeneralInformationExpanded = false;

  vm.handleExpandAudit = _handleExpandAudit;
  vm.handleExpandGeneralInformation = _handleExpandGeneralInformation;

  vm.handleEdit = _handleEdit;
  vm.handleRunDetailReport = _handleRunDetailReport;
  vm.handleDelete = _handleDelete;

  /** *********************************************
   * Event Handlers
   */

  function _handleExpandAudit() {
    vm.isExpanded = !vm.isExpanded;
  }

  function _handleExpandGeneralInformation() {
    vm.isGeneralInformationExpanded = !vm.isGeneralInformationExpanded;
  }

  function _handleEdit($event) {
    loaderService.showViewLoader = true;
    amDataService.getDataTypes().then((getDataTypesResponse) => {
      amDataService.getAudit(vm.audit.auditId).then((getAuditResponse) => {
        _showEditAuditDialog($event, getAuditResponse, getDataTypesResponse);
      });
    });
  }

  function _handleRunDetailReport() {
    loaderService.showViewLoader = true;
    return amDataService.getAuditTrailDetailReport().then(reportData => {
      const reportId = reportData.data.reportId;
      const parameters = [];
      parameters.push({
        parameterName: 'AuditID',
        parameterValue: vm.audit.auditId.toString(),
      });
      parameters.push({
        parameterName: 'ItemTypeID',
        parameterValue: '-1',
      });
      parameters.push({
        parameterName: 'CompletedAfter',
        parameterValue: null,
      });
      reportsDataService.viewAppReportByGroup(vm.groupId, reportId, 'PDF', parameters, false).then(response => {
        reportsDataService.download(response);
        loaderService.showViewLoader = false;
      });
    });
  }

  function _handleDelete($event) {
    return _showDeleteCompletedAuditConfirmDialog($event);
  }

  /** *********************************************
   * Private Functions
   */

  function _showDeleteCompletedAuditConfirmDialog($event) {
    ssDialogService.dialogs.auditTrail.deleteCompletedAuditConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete Active Audit Exam?',
        message: `Are you sure you want to delete audit/exam "${vm.audit.name}"?`,
        handleYesClick: _handleConfirmDelete,
        handleNoClick: _handleCancelDelete,
      })
    );
    return ssDialogService.show(ssDialogService.dialogs.auditTrail.deleteCompletedAuditConfirmDialog);
  }

  function _showEditAuditDialog($event, getAuditResponse, getDataTypesResponse) {
    ssDialogService.dialogs.auditTrail.editAuditDialog = ssDialogService.alert(
      editAuditDialog.getOptions($event, {
        audit: getAuditResponse.data,
        agencies: amSharedModelService.agencies,
        auditTypes: amSharedModelService.auditTypes,
        coordinators: amSharedModelService.applicationUsers,
        dataTypes: getDataTypesResponse.data.result,
        refreshAudit: true,
      })
    );
    return ssDialogService.show(ssDialogService.dialogs.auditTrail.editAuditDialog);
  }

  function _handleConfirmDelete() {
    loaderService.showViewLoader = true;
    return amDataService.deleteAudit(vm.audit.auditId)
      .then(() => {
        alerts.success('The audit has been deleted successfully.');
        $rootScope.$broadcast('refreshAMAudits');
        _closeDeleteDialog();
      }).catch(() => {
        alerts.error('Error occurred while deleting audit.');
      }).finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  function _handleCancelDelete() {
    _closeDeleteDialog();
  }

  function _closeDeleteDialog() {
    ssDialogService.hide(ssDialogService.dialogs.auditTrail.deleteCompletedAuditConfirmDialog);
  }
}

CompletedAuditController.$inject = [
  '$filter',
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'amDataService',
  'amSharedModelService',
  'confirmDialog',
  'editAuditDialog',
  'loaderService',
  'orgDataService',
  'ssDialogService',
  'reportsDataService',
];
